const XLSX = require("xlsx");

export function formatExcelLaporanBelanja(datas = [], date = new Date()) {
  try {
    if (datas?.length <= 0) throw new Error("datas empty array");

    // Prepare the data for the worksheet
    let reportData = [];
    let no = 1;
    let kodeOrderOngkirAdded = new Set();

    datas
      .sort(
        (a, b) =>
          a?.kode_order?.localeCompare(b?.kode_order) ||
          a?.mitra_upline?.localeCompare(b?.mitra_upline)
      )
      .forEach((data) => {
        data.products?.forEach((product, idx) => {
          const showOngkir = !kodeOrderOngkirAdded.has(data.kode_order);
          if (showOngkir) kodeOrderOngkirAdded.add(data.kode_order);

          reportData.push({
            no: no++,
            tanggal_order: data.created_at,
            tanggal_packing: data.packing_at,
            tanggal_delivery: data.delivery_at,
            tanggal_completed: data.completed_at,
            no_order: data.kode_order,
            distributor: data?.mitra_upline,
            username: data.username,
            variant_id: product.variant_id,
            item_barang: `${product.name_product} - ${product.color}, ${product.size}`,
            name_product: `${product.brand}(${
              (product.products_kategori3 ||
                product.products_kategori2 ||
                product.products_kategori1) ??
              "-"
            })`,
            price_tags: product.price_tags,
            qty: product.qty,
            disc: `${product.diskon_presentase}%`,
            subTotal: product.product_aftr_disc,
            ongkir: showOngkir ? data.biaya_pengiriman : "",
            ekspedisi: showOngkir ? data.name_service : "",
            no_resi: showOngkir ? data.resi : "",
            metode_transaction: showOngkir ? data.type : "",
            type_transaction: showOngkir ? data.type_transaction : "",
            status_transaction: showOngkir ? data.status_transaction : "",
            status_shipping: showOngkir ? data.status_shipping : "",
          });
        });
      });

    // Define the worksheet columns
    const worksheetColumns = [
      { header: "NO", key: "no", width: 10 },
      { header: "TGL. ORDER", key: "tanggal_order", width: 15 },
      { header: "TGL. DIPROSES", key: "tanggal_packing", width: 15 },
      { header: "TGL. PENGIRIMAN", key: "tanggal_delivery", width: 15 },
      { header: "TGL. SELESAI", key: "tanggal_completed", width: 15 },
      { header: "NOMER ORDER", key: "no_order", width: 20 },
      { header: "DISTRIBUTOR", key: "distributor", width: 25 },
      { header: "USERNAME", key: "username", width: 25 },
      { header: "BARCODE NIS", key: "variant_id", width: 15 },
      { header: "ITEM BARANG", key: "item_barang", width: 35 },
      { header: "NAMA PRODUK", key: "name_product", width: 25 },
      { header: "HARGA", key: "price_tags", width: 10 },
      { header: "JUMLAH", key: "qty", width: 10 },
      { header: "DISKON", key: "disc", width: 10 },
      { header: "SUBTOTAL", key: "subTotal", width: 15 },
      { header: "ONGKOS KIRIM", key: "ongkir", width: 15 },
      { header: "EKSPEDISI", key: "ekspedisi", width: 15 },
      { header: "NOMER RESI", key: "no_resi", width: 25 },
      { header: "METODE PENGIRIMAN", key: "metode_transaction", width: 20 },
      { header: "TIPE TRANSAKSI", key: "type_transaction", width: 20 },
      { header: "STATUS TRANSAKSI", key: "status_transaction", width: 20 },
      { header: "STATUS PENGIRIMAN", key: "status_shipping", width: 20 },
    ];

    // Create a new workbook and add a worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(reportData, {
      header: worksheetColumns.map((col) => col.key),
    });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Add autofilter to the worksheet
    worksheet["!autofilter"] = {
      ref: `A1:${String.fromCharCode(65 + worksheetColumns.length - 1)}1`,
    };

    // Set column widths
    worksheetColumns.forEach((col, idx) => {
      const colLetter = String.fromCharCode(65 + idx); // 'A' is 65 in ASCII
      worksheet[`${colLetter}1`] = { v: col.header, t: "s" }; // Set header text
      worksheet[`${colLetter}1`].s = { font: { bold: true } }; // Make header bold
      const wscols = worksheet["!cols"] || [];
      wscols[idx] = { wch: col.width };
      worksheet["!cols"] = wscols;
    });

    // Write the workbook to a file
    XLSX.writeFile(workbook, `Laporan Belanja : ${date}.xlsx`);

    console.log("Excel report generated as Laporan_Belanja.xlsx");
  } catch (error) {
    console.log(error);
    throw new Error(error?.message);
  }
}

// export function formatExcelLaporanBelanja1(datas = [], date) {
//   try {
//     if (datas.length === 0) throw new Error("datas is an empty array");

//     // Create a new workbook and add a worksheet
//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet([]);

//     let currentRow = 0;

//     // Group data by mitra_upline
//     const groupedData = datas?.reduce((acc, curr) => {
//       if (!acc[curr.mitra_upline]) {
//         acc[curr.mitra_upline] = [];
//       }
//       acc[curr.mitra_upline].push(curr);
//       return acc;
//     }, {});

//     for (const [mitraUpline, dataGroup] of Object.entries(groupedData)) {
//       // Add headers for each mitra_upline section
//       const headers = [
//         ["NAMA DISTRIBUTOR", "", "", "", mitraUpline],
//         [
//           "PERIODE",
//           "",
//           "",
//           "",
//           !date
//             ? `${format(date, "dd MM YYYY")} s.d ${format(date, "dd MM YYYY")}`
//             : date,
//         ],
//         [
//           "NO.",
//           "TANGGAL",
//           "TGL. PENGIRIMAN",
//           "NO. ORDER",
//           "DB",
//           "AGEN",
//           "BARCODE NIS",
//           "ITEM BARANG",
//           "KATEGORI",
//           "HARGA",
//           "JUMLAH",
//           "DISKON",
//           "SUBTOTAL",
//           "ONGKIR",
//           "EKSPEDISI",
//           "NO. RESI",
//           "TYPE PEMBAYARAN",
//           "STATUS TRANSAKSI",
//           "STATUS PENGIRIMAN",
//         ],
//       ];

//       XLSX.utils.sheet_add_aoa(worksheet, headers, {
//         origin: `A${currentRow + 1}`,
//       });

//       currentRow += 3;

//       // Add data rows for each mitra_upline section
//       let sectionTotalOrders = 0;
//       let sectionTotalAmount = 0;
//       let sectionTotalOngkir = 0;

//       const processedOrders = new Set();

//       dataGroup.forEach((data, idx) => {
//         data.products.forEach((product, productIdx) => {
//           const isFirstOccurrence = !processedOrders.has(data.kode_order);
//           if (isFirstOccurrence) {
//             processedOrders.add(data.kode_order);
//           }

//           const row = [
//             sectionTotalOrders + 1,
//             data.created_at,
//             data.delivery_at,
//             data.kode_order,
//             data.mitra_upline,
//             data.level_mitra == 2 || data.level_mitra == 3 ? data.username : "",
//             product.variant_id,
//             `${product.name_product} - ${product.color}, ${product.size}`,
//             `${product.brand.toUpperCase()}(${
//               (product.products_kategori3 ||
//                 product.products_kategori2 ||
//                 product.products_kategori1) ??
//               "-"
//             })`.trim(),
//             product.price_tags,
//             product.qty,
//             `${product.diskon_presentase}%`,
//             product.product_aftr_disc,
//             isFirstOccurrence ? data.biaya_pengiriman : "",
//             isFirstOccurrence ? data.name_service : "",
//             isFirstOccurrence ? data.resi || "" : "",
//             data.type_transaction,
//             data.status,
//             data.status_shipping,
//           ];

//           XLSX.utils.sheet_add_aoa(worksheet, [row], {
//             origin: `A${currentRow + 1}`,
//           });

//           currentRow++;
//           sectionTotalOrders++;
//           sectionTotalAmount += product.product_aftr_disc;

//           if (isFirstOccurrence) {
//             sectionTotalOngkir += data.biaya_pengiriman;
//           }
//         });
//       });
//     }

//     // Set column widths
//     const worksheetColumns = [
//       { wch: 5 }, // NO.
//       { wch: 10 }, // TANGGAL
//       { wch: 20 }, // NO. ORDER
//       { wch: 25 }, // DB
//       { wch: 30 }, // Agen
//       { wch: 20 }, // BARCODE NIS
//       { wch: 30 }, // ITEM BARANG
//       { wch: 25 }, // KATEGORI
//       { wch: 15 }, // HARGA
//       { wch: 10 }, // JUMLAH
//       { wch: 10 }, // DISKON
//       { wch: 15 }, // SUBTOTAL
//       { wch: 15 }, // ONGKIR
//       { wch: 20 }, // EKSPEDISI
//       { wch: 25 }, // NO. RESI
//       { wch: 25 }, // TYPE PEMBAYARAN
//       { wch: 25 }, // STATUS TRANSAKSI
//       { wch: 25 }, // STATUS PENGIRIMAN
//     ];
//     worksheet["!cols"] = worksheetColumns;

//     // Merge cells for headers
//     worksheet["!merges"] = [];
//     for (let i = 0; i < currentRow; i++) {
//       if (
//         worksheet[`A${i + 1}`] &&
//         worksheet[`A${i + 1}`].v === "NAMA DISTRIBUTOR"
//       ) {
//         worksheet["!merges"].push(
//           { s: { r: i, c: 0 }, e: { r: i, c: 3 } },
//           { s: { r: i, c: 4 }, e: { r: i, c: 14 } }
//         );
//         worksheet["!merges"].push(
//           { s: { r: i + 1, c: 0 }, e: { r: i + 1, c: 3 } },
//           { s: { r: i + 1, c: 4 }, e: { r: i + 1, c: 14 } }
//         );
//       }
//     }

//     // Add the worksheet to the workbook
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//     // Write the workbook to a file
//     XLSX.writeFile(
//       workbook,
//       `Laporan_Produk_${
//         !date
//           ? `${format(date, "dd MM YYYY")} s.d ${format(date, "dd MM YYYY")}`
//           : date
//       }.xlsx`
//     );

//     console.log("Excel report generated as Laporan_Produk.xlsx");
//   } catch (error) {
//     console.log(error?.message);
//   }
// }
